import { useTheme } from '@mui/material';

export const BenefitImproveIcon = () => {
    const theme = useTheme();
    const {
        stroke: { primary: primaryStroke },
        background: { primary: primaryBackground },
    } = theme.colors.other.icon;

    return (
        <svg
            width="56"
            height="56"
            viewBox="0 0 56 56"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M21.1901 54.25H12.25V27.4168H21.1901V54.25ZM21.1901 52.0139C24.1323 53.4859 27.377 54.2515 30.6666 54.25H40.0536C42.0383 54.2535 43.9677 53.5961 45.5378 52.3816C47.1079 51.167 48.2294 49.4643 48.7255 47.5417L52.3463 33.0518C52.5251 32.3873 52.5482 31.6906 52.414 31.0157C52.2797 30.3408 51.9915 29.7061 51.572 29.1608C51.1524 28.6156 50.6128 28.1746 49.995 27.8721C49.3773 27.5696 48.6981 27.4138 48.0103 27.4168H41.3053C41.5649 24.6148 41.6545 21.7996 41.5735 18.9867C41.5441 17.6462 40.9882 16.3713 40.026 15.438C39.0639 14.5047 37.773 13.9881 36.4329 14.0002H36.3212C35.2023 13.9987 34.1165 14.3789 33.2428 15.0782C32.3691 15.7775 31.76 16.7539 31.5159 17.8463C30.7113 21.2004 29.862 24.1745 29.035 26.6118C28.7363 27.4965 28.1684 28.2654 27.4109 28.8108C26.6533 29.3562 25.7441 29.6506 24.8108 29.6529H21.1901V52.0139Z"
                fill={primaryBackground}
            />
            <path
                d="M16.3333 49H7V21H16.3333V49ZM16.3333 46.6667C19.405 48.2027 22.7924 49.0016 26.2267 49H36.0267C38.0986 49.0036 40.1129 48.3177 41.752 47.0503C43.3912 45.783 44.562 44.0062 45.08 42L48.86 26.88C49.0467 26.1867 49.0709 25.4596 48.9307 24.7554C48.7905 24.0512 48.4897 23.3888 48.0517 22.8199C47.6137 22.2509 47.0503 21.7907 46.4053 21.4751C45.7604 21.1594 45.0514 20.9968 44.3333 21H37.3333C37.6044 18.0761 37.6979 15.1385 37.6133 12.2033C37.5827 10.8046 37.0023 9.4742 35.9978 8.5003C34.9934 7.5264 33.6457 6.98739 32.2467 7H32.13C30.962 6.99841 29.8283 7.3952 28.9162 8.12487C28.0041 8.85453 27.3682 9.87344 27.1133 11.0133C26.2733 14.5133 25.3867 17.6167 24.5233 20.16C24.2115 21.0831 23.6186 21.8855 22.8277 22.4546C22.0369 23.0237 21.0877 23.331 20.1133 23.3333H16.3333V46.6667Z"
                stroke={primaryStroke}
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
